import React from 'react';
import { Field } from 'formik';

import FormInput from '../../../components/FormInput';
import SelectInput from '../../../components/FormInput/SelectInput';
import Box from '../../../components/layout/Box';
import Text from '../../../components/Text';

import { conditionOptions } from './conditionOptions';

const Details = ({
  values,
  errors,
  showErrors,
  handleChange,
  showContactError,
}) => {
  return (
    <>
      <FormInput
        name="newBookAutofillPrice"
        value={values.price}
        onChange={handleChange('price')}
        label="Pris"
        error={showErrors && errors.price}
      />

      <SelectInput
        name="newBookAutofillCondition"
        value={values.conditionId}
        onChange={handleChange('conditionId')}
        label="Bokens skick"
        error={showErrors && errors.conditionId}
        options={conditionOptions}
      />

      <FormInput
        name="newBookAutofillComment"
        value={values.comment}
        onChange={handleChange('comment')}
        label="Kommentar"
        error={showErrors && errors.comment}
        as="textarea"
        style={{ height: 100, minHeight: 100, maxHeight: 200 }}
      />

      <Box className="flex-column mt-5">
        <Text variant="sectionTitle">Jag vill bli kontaktad via</Text>
        {showContactError && (
          <Text color="errorColor">Välj minst ett alternativ</Text>
        )}
        <Box className="mt-2">
          <label className="d-flex flex-row">
            <Field
              type="checkbox"
              name="contactEmail"
              onChange={handleChange('contactEmail')}
              style={{ marginRight: 8, width: 20, height: 20 }}
            />
            E-post
          </label>
        </Box>

        <Box>
          <label className="d-flex flex-row">
            <Field
              type="checkbox"
              onChange={handleChange('contactPhone')}
              name="contactPhone"
              style={{ marginRight: 8, width: 20, height: 20 }}
            />
            <div>Telefon</div>
          </label>
        </Box>
      </Box>
    </>
  );
};

export default Details;
